/**
 * Arabic Technology Translations
 * 技术页翻译模块 - 阿拉伯语
 * 
 * 包含红外技术原理、技术优势、科学原理等翻译
 */

import type { TechnologyTranslations } from '../../types';

export const arTechnology: TechnologyTranslations = {
  title: 'علم الدفء',
  subtitle: 'اكتشف كيف تمنح تقنية الأشعة تحت الحمراء البعيدة مساحتك تدفئة أكثر كفاءة وراحة.',
  section1: {
    title: 'دفء يملأ المكان كأشعة الشمس',
    desc1: 'تعتمد أجهزة التدفئة التقليدية على تسخين الهواء أساسًا، فيرتفع الهواء الساخن إلى السقف، ما يسبب تفاوتًا في درجات الحرارة ويحرّك الغبار في الجو.',
    desc2: 'تعمل التدفئة بالأشعة تحت الحمراء البعيدة بطريقة مختلفة تمامًا. فهي، مثل الشمس، تبعث موجات كهرومغناطيسية تدفئ الأجسام والأشخاص مباشرة. وتمتص الجدران والأرضيات والأثاث هذه الحرارة ثم تطلقها تدريجيًا، ليبقى المكان دافئًا ومريحًا بدرجة ثابتة.',
    radiant: 'نقل الحرارة بالإشعاع',
  },
  section2: {
    title: 'التقنية الأساسية للتدفئة',
    intro: 'عنصر التسخين المصمم خصيصًا لدينا، مع الطلاء النانوي الحاصل على براءة اختراع، يقدّم أداء تدفئة فائقًا.',
    surface: 'الطلاء النانوي',
    surfaceDesc: 'يزيد الطلاء النانوي الحاصل على براءة اختراع مساحة الإشعاع بشكل ملحوظ، مع معامل انبعاث يصل إلى 86٪.',
    rapid: 'تسخين سريع',
    rapidDesc: 'يصل الألمنيوم عالي التوصيل الحراري إلى الدرجة المثالية خلال 5 دقائق فقط.',
    durability: 'عمر خدمة طويل جدًا',
    durabilityDesc: 'مصمم لعمر تشغيلي يزيد على 25 عامًا دون صيانة.',
    nanoTitle: 'تقنية النانو',
  },
  infraredIntroduction: {
    title: 'تقنية الأشعة تحت الحمراء البعيدة المتقدمة',
    desc: 'نستفيد من الجزء غير المرئي من الطيف الضوئي لتحقيق كفاءة حرارية عالية. وتعمل تقنيتنا على تحسين نطاق الأشعة تحت الحمراء البعيدة لزيادة امتصاص جسم الإنسان للحرارة إلى أقصى حد.',
    optimalWavelength: 'الطول الموجي الأمثل',
    optimalWavelengthDesc: 'مضبوطة على تردد محدد ينسجم طبيعيًا مع جزيئات الماء في الجسم، لضمان أقصى امتصاص للحرارة والاحتفاظ بها.',
    superiorEfficiency: 'كفاءة فائقة',
    superiorEfficiencyDesc: 'تتفوق على نطاقي الأشعة تحت الحمراء القريبة والمتوسطة. فالأشعة تحت الحمراء البعيدة تمنح دفئًا لطيفًا ومتوازنًا من دون حرارة حادة أو جفاف في الهواء.',
    radiantEnergy: 'الطاقة الإشعاعية',
    radiantEnergyDesc: 'تطلق حرارة إشعاعية نقية تصل مباشرة إلى الأجسام والأشخاص، من دون الاعتماد على تدوير الهواء، ما يحد من هدر الطاقة.',
  },
  healthBenefits: {
    title: 'ما بعد التدفئة: فوائد صحية',
    desc: 'لا تقتصر الأشعة تحت الحمراء البعيدة على التدفئة فقط؛ فطولها الموجي الفريد يساعد على خلق بيئة أكثر صحة وراحة، ويدعم عافيتك بشكل فعّال.',
    card1: {
      title: '"ضوء الحياة"',
      desc: 'عند العمل ضمن نطاق 8-15 ميكرومتر، تتوافق هذه الحرارة طبيعيًا مع تردد جسمك. والنتيجة دفء لطيف يمتصه الجسم بعمق ويشعرك براحة طبيعية.',
    },
    card2: {
      title: 'تنفّس نقي',
      desc: 'على عكس أجهزة التدفئة التقليدية بالحمل الحراري، لا تثير الغبار ولا تنشر مسببات الحساسية ولا تُجفف الهواء، ما يحمي البشرة وصحة الجهاز التنفسي.',
    },
    card3: {
      title: 'دفء عميق مهدّئ',
      desc: 'تساعد الموجات الحرارية ذات النفاذ العميق على تنشيط الدورة الدموية الدقيقة، وإرخاء العضلات، وتخفيف تيبّس الشتاء.',
    },
  },
};
